const DATE_FORMAT = /^(\d{2})\/(\d{2})\/(\d{4})$/;

export const dateAdapter = {
  parse: (
    value: string,
    createDate: (year: string, month: string, day: string) => Date
  ): Date | undefined => {
    if (!value) {
      return;
    }
    const match = value.match(DATE_FORMAT);
    if (match) {
      return createDate(match[3], match[2], match[1]);
    }
    return;
  },
  format: (date: Date): string => {
    if (!date) {
      return '';
    }

    const dd = date.getDate().toString(10).padStart(2, '0');
    const mm = (date.getMonth() + 1).toString(10).padStart(2, '0');
    const yyyy = date.getFullYear().toString(10);

    return `${dd}/${mm}/${yyyy}`;
  }
};
